module.exports = __webpack_public_path__ + "static/media/IMG_0355.f2e050ab.jpg";